import cx from "classnames";
import { Flex, Text, ScrollArea } from "@radix-ui/themes";
import * as Tabs from "@radix-ui/react-tabs";
import styles from "./Evaluation.styles.module.scss";

export interface EvaluationTabItem {
  value: string;
  title: string;
}

function EvaluationScorecardTab({ value, title }: EvaluationTabItem) {
  return (
    <Tabs.Trigger key={value} className={cx(styles.Trigger)} value={value}>
      <Flex width={"100%"} maxWidth={"100%"} gap={"3"} align={"center"}>
        <Flex
          width={"100%"}
          maxWidth={"100%"}
          direction={"column"}
          align={"start"}
        >
          <Flex
            width={"100%"}
            maxWidth={"100%"}
            gap={"4"}
            justify={"between"}
            align={"center"}
          >
            <Text
              size={"2"}
              color={"gray"}
              weight={"medium"}
              highContrast
              truncate
            >
              {title}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </Tabs.Trigger>
  );
}

interface EvaluationTabsProps {
  tabs: EvaluationTabItem[];
  value: string;
  onChange: (value: string) => void;
}

export function EvaluationScorecardTabs({
  tabs,
  value,
  onChange,
}: EvaluationTabsProps) {
  return (
    <Tabs.Root
      className={styles.EvaluationTabs}
      value={value}
      onValueChange={onChange}
    >
      <ScrollArea scrollbars={"horizontal"}>
        <Tabs.List className={styles.List}>
          {tabs
            .sort((a, b) => b.title.localeCompare(a.title))
            .map((tab) => (
              <EvaluationScorecardTab key={tab.value} {...tab} />
            ))}
        </Tabs.List>
      </ScrollArea>
    </Tabs.Root>
  );
}
